<template>

	<span :class="{hasUrlKeyword:!inModal}">

		<slot name="url-keyword" />

		<section :class="{ minimized: true, 'outer-pad': true, 'in-modal': inModal }">
			<div class="minimized-inner">
				<span>
				<span 
					v-for="(m,mIndex) in listItems" 
					:key="'mini-'+mIndex" 
					:class="{'filter-button':true,'has-tip':!!m.tip,selected:!!selected[m.type],'text-only':!!m.textOnly}"
					@click="minimize(m)"
				>
					<span class="svg no-bg" v-if="m.svg"><font-awesome-icon :icon="m.svg" /></span> {{m.label}} <span class="svg" v-if="m.maximize"><font-awesome-icon icon="maximize" /></span> 
					<Tip position="fromRight" :class="{mini:true,theTip:true,grey:true}" :labelStyles="{opacity:0}" v-if="m.tip">{{m.tip}}</Tip>
				</span>
				</span>
			</div>
			<slot name="frequency" />
		</section>

	</span>

</template>

<script>
import Tip from './Tip.vue'
export default {
  name: 'MinimizeList',
  components: {
	Tip
  },
  props: {
  	listItems: {
  		type: Array,
		default: () => []
  	},
	inModal: {
		type: Boolean,
		default: false
	},
	selected: {
		type: Object,
		default: () => {}
	}
  },
  methods: {
	minimize (info) {
		this.$emit('minimize',info)
	}
  }
}
</script>
<style lang="less" scoped>

@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';

.minimized {

	text-align: center;
	min-width: 10px;
	min-height: 58px;
	margin-bottom: 20px;
	background-color: #394559;
	position: relative;
	.rounded(5px);
	margin: 0 12px 20px;

	&.in-modal {

		min-height: 56px;

	}

	.filter-button {

		background-color: #fff;
		padding: 7px 10px 5px 6px;
		display: inline-block;
		margin: 20px 10px 0;
		position: relative;
		border:1px solid @darkContrast;
		cursor: pointer;
		.rounded(5px);
		.trans;

		.theTip {

			position: absolute;
			top: 0;
			right: 0;
			z-index: 5; 
			width: 100%;
    		height: 100%;

		}

		&.has-tip {

			text-decoration: underline;
			text-decoration-style: dashed;

		}

		.svg {

			background-color: @darkContrast;
			vertical-align: top;
			width: 16px;
			height: 16px;
			display: inline-block;
			padding: 0;
			position: relative;
			.rounded(50%);
			.trans;
			cursor: pointer;
			margin-top: 3px;
			
			svg {

				fill:#fff;
				color: #fff;
				width:50%;
				display: block;
				position: absolute;
				left: 25%;
				top: 1.5%;
				.trans;

			}

			&.no-bg {

				background-color: transparent;
				width: 20px;
    			height: 20px;
				margin-top: 0;

				svg {

					fill: #394559;
					color: #394559;
					width: 100%;
    				height: 100%;
					left: 0;
					top:0;

				}

			}

		}

		&:hover, &.selected {

			background-color: @darkContrast;
			color: #fff;

			.svg {

				&.no-bg {

					svg {

						fill: #fff;
						color: #fff;

					}

				}

				&:not(.no-bg) {
					
					background-color: #fff;

					svg {

						fill: @darkContrast;
						color: @darkContrast;

					}

				}

			}

			&:not( .has-tip ) {

				background-color: fade( @formDefaultColour, 60% ) !important;
				border-color: fade( @formDefaultColour, 60% ) !important;

			}
 
		}

		&.selected {

			background-color: @formDefaultColour !important;
			border-color: @formDefaultColour !important;

			&:not( .has-tip ) {

				background-color: @formDefaultColour !important;
				border-color: @formDefaultColour !important;

			}

		}

		&.text-only {

			color: #fff !important;
			background: none!important;

			.svg {

				svg {

					fill: #fff !important;
					color: #fff !important;

				}

			}

		}

	}

	&.in-modal {

		.filter-button {

			background-color: #F8FAFB;

			&:hover {
				background-color: @darkContrast;
			}

		}

	}

}
@media screen and (min-width: 1024px) {
	.minimized {
		text-align: left;
		padding: 0 380px 0 0;
		margin: 0 24px 14px;
		background-color: #394559;
		border-radius: 5px;

		.minimized-inner {

			padding: 10px 10px 0 10px;

		}

		.filter-button {

			margin: 0 10px 10px 0;

			&:last-child {

				margin-right: 0;

			}

		}
		&.in-modal {
			padding-bottom: 0px;
			margin: 0;
		}
	}
	.hasUrlKeyword {
		display: flex;
		margin: 0 24px 14px;
		justify-content: space-between;
		.minimized {

			margin: 0;
			flex-grow: 1;

		}
	}
}
</style>